import { Alert, AlertColor, Snackbar } from '@mui/material'
import React from 'react'

interface DeleteVersionErrorProps {
    open: boolean
    onClose: () => void
    message: string
    severity?: AlertColor
    autoHideDuration?: number
}

const ErrorAlert: React.FC<DeleteVersionErrorProps> = ({ open, onClose, message, severity = 'error', autoHideDuration }) => {
    return (
        <Snackbar
            open={open}
            onClose={onClose}
            autoHideDuration={autoHideDuration}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert severity={severity} variant="filled" onClose={onClose}>{message}</Alert>
        </Snackbar>
    )
}

export default ErrorAlert
